export default __webpack_public_path__ + "static/media/Sprayzapp-logo-final-black.4ab366a2.png";